import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const PremiumAdminEvent: LoadableType<{}> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-analytics-eventsPremiumAdminEvent" */ '../src/analytics-events/PremiumAdminEvent.tsx'
			)
		).PremiumAdminEvent,
});
